import React, { useEffect } from 'react';
import { greenCheck } from '../../assets/hostedassets';

interface PasswordStrengthCheckerProps {
    password: string;
    onValidationChange?: (isValid: boolean) => void;
    isFocused: boolean;
}

const PasswordStrengthChecker = ({ password, onValidationChange, isFocused }: PasswordStrengthCheckerProps) => {
    // Define checks/rules as key value pair
    const rules = {
        length: {
            label: 'At Least 12 Characters',
            passed: password.length >= 12,
        },
        lower: {
            label: 'Lower Case Letter (a-z)',
            passed: /[a-z]/.test(password),
        },
        upper: {
            label: 'Upper Case Letter (A-Z)',
            passed: /[A-Z]/.test(password),
        },
        special: {
            label: 'Special Characters (e.g. !@#$%^&*)',
            passed: /[!@#$%^&*(),.?\":{}|<>]/.test(password),
        },
    };

    // Check if all rules are passed
    const isValid = Object.values(rules).every((rule) => rule.passed);

    // Notify parent about validation change
    useEffect(() => {
        onValidationChange?.(isValid);
    }, [isValid, onValidationChange]);

    if (!isFocused) return null;

    return (
        isFocused && (
            <div>
                <p style={{ color: 'grey', fontSize: '12px' }}>Your password must contain:</p>
                {Object.entries(rules).map(([key, rule]) => (
                    <ConditionItem key={key} text={rule.label} passed={rule.passed} />
                ))}
            </div>
        )
    );
};

interface ConditionItemProps {
    text: string;
    passed: boolean;
}

const ConditionItem = ({ text, passed }: ConditionItemProps) => (
    <p
        style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            color: passed ? '#33cc33' : 'gray',
            fontSize: '12px',
        }}
    >
        {passed ? <img src={greenCheck} /> : <span style={{ marginRight: '8px' }}>-</span>}
        {text}
    </p>
);

export default PasswordStrengthChecker;
